import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../api/axiosClient";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import DashboardStyles02 from "../script/DashboardStyles02";
import styles from "../script/dashboardStyles";
import Resume from "./Resume";
import UserProfile from "./UserProfile";
import { BrainCircuit } from "lucide-react";

import {
  LayoutDashboard,
  BookOpen,
  CreditCard,
  TrendingUp,
  LogOut,
  UserCircle,
  Hash,
  Lock,
  Menu,
  X,
  Brain,
  Building2,
  GraduationCap,
  Flame,
  CalendarCheck,
  ClipboardCheck,
  CheckCircle,
  Award,
  BarChart3,
  Target,
} from "lucide-react";

import "../styles/dashboardCalender.css";

import { Outlet } from "react-router-dom";

import missionMaster from "../assets/badges/Mission Master.png";
import algorithmVirtuoso from "../assets/badges/Algorithm Virtuoso.png";
import interviewMaestro from "../assets/badges/Interview Maestro.png";
import problemArchitect from "../assets/badges/Problem Architect.png";
import interviewAce from "../assets/badges/interview ace.png";
import problemSolver from "../assets/badges/problem solver.png";
import DashboardNavbar from "../Components/DashboardNavbar";

// ---------------All graphs-----------

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  LineChart,
  Line,
  LabelList,
  CartesianGrid,
  ComposedChart,
  ScatterChart,
  Scatter,
  Legend,
  Area,
  AreaChart,
  PolarRadiusAxis,
} from "recharts";

import confetti from "canvas-confetti";
import * as faceapi from "face-api.js";
import FloatingButtons from "./Floatingicon";
import GetStartedCard from "./Getstartedcard";

/* =========================================================================
   DESIGN SYSTEM
   A small, consistent token set used everywhere below so the whole
   dashboard reads as one product instead of a pile of separate widgets.
   ========================================================================= */

const T = {
  bg: "#f5f6fb",
  surface: "#ffffff",
  surfaceAlt: "#fafbff",
  border: "#eef0f6",
  ink: "#0f172a",
  inkSoft: "#475569",
  inkFaint: "#94a3b8",
  primary: "#6d28d9",
  primarySoft: "#ede9fe",
  gradient: "linear-gradient(135deg,#7c3aed,#a855f7)",
  radius: 20,
  shadow: "0 10px 28px rgba(15,23,42,0.06)",
};

const TABS = [
  { key: "overview", label: "Overview", icon: LayoutDashboard },
  { key: "career", label: "Career", icon: Target },
  { key: "analytics", label: "Analytics", icon: BarChart3 },
  { key: "badges", label: "Badges", icon: Award },
  { key: "calendar", label: "Login Calendar", icon: CalendarCheck },
];

const SectionHeading = ({ eyebrow, title, desc }) => (
  <div style={{ marginBottom: 20 }}>
    {eyebrow && (
      <div
        style={{
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "1.5px",
          textTransform: "uppercase",
          color: T.primary,
          marginBottom: 6,
        }}
      >
        {eyebrow}
      </div>
    )}
    <h2
      style={{
        margin: 0,
        fontSize: 22,
        fontWeight: 800,
        color: T.ink,
        letterSpacing: "-0.3px",
      }}
    >
      {title}
    </h2>
    {desc && (
      <p style={{ margin: "6px 0 0", fontSize: 13.5, color: T.inkSoft }}>
        {desc}
      </p>
    )}
  </div>
);

const Panel = ({ children, style }) => (
  <div
    style={{
      background: T.surface,
      borderRadius: T.radius,
      border: `1px solid ${T.border}`,
      boxShadow: T.shadow,
      padding: 22,
      ...style,
    }}
  >
    {children}
  </div>
);

const Card = ({ children }) => (
  <div
    style={{
      padding: "20px",
      borderRadius: "18px",
      minWidth: "220px",
      width: "100%",
    }}
  >
    {children}
  </div>
);

export default function Dashboard() {
  
  // ✅ TAB STATE — this is what turns the page into organized categories
  const [activeTab, setActiveTab] = useState("overview");

  const gridContainer = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "20px",
  };

  const cardBox = {
    background: "#ffffff",
    padding: "18px",
    borderRadius: "18px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.06)",
    lineHeight: "1.7",
    fontFamily: "Inter, sans-serif",
    transition: "all 0.3s ease",
  };

  const headingStyle = {
    fontFamily: "Outfit, sans-serif",
    fontWeight: "600",
    fontSize: "18px",
    letterSpacing: "0.3px",
  };

  const subHeadingStyle = {
    fontFamily: "Outfit, sans-serif",
    fontWeight: "600",
    fontSize: "15.5px",
  };

  const textStyle = {
    fontFamily: "Inter, sans-serif",
    fontSize: "14px",
    color: "#475569",
  };

  const listStyle = {
    paddingLeft: "18px",
    marginTop: "10px",
    color: "#334155",
    lineHeight: "1.7",
    fontSize: "14px",
  };

  const reportRef = useRef(null);
  const reviewRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        reportRef.current &&
        !reportRef.current.contains(event.target) &&
        reviewRef.current &&
        !reviewRef.current.contains(event.target)
      ) {
        setActiveMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //function for detecting the inspect

  function enableDevToolsProtection(triggerViolation, video) {
    const handleKeyDown = (e) => {
      //F12 Key
      if (e.key === "F12") {
        e.preventDefault();

        triggerViolation(
          "Developer Tools Detected 🚫",
          "You are Eliminated",
          "DEVTOOLS F12",
          video,
        );
      }

      //Ctrl + shift + I
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") {
        e.preventDefault();

        triggerViolation(
          "Developer Tools Detected 🚫",
          "You are Eliminated",
          "DEVTOOLS_CTRL_SHIFT_I",
          video,
        );
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    //cleaning function
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  // -------------------password all----------------------

  const checkAccess = async (callback) => {
    const { value: password } = await Swal.fire({
      title: "Enter Access Password 🔒",
      input: "password",
      inputPlaceholder: "Enter password",
      confirmButtonText: "Unlock",
      showCancelButton: true,
    });

    if (password === "224488") {
      callback(); // ✅ allow access
    } else if (password) {
      Swal.fire("Wrong Password ❌", "Access Denied", "error");
    }
  };

  // 🔥 ADD THIS LINE HERE
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);
  const [openResumePopup, setOpenResumePopup] = useState(false);
  const leakBox = (color) => ({
    padding: 12,
    borderRadius: 12,
    background: "#fff",
    borderLeft: `4px solid ${color}`,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    fontWeight: 700,
  });

  // -----------------------Badgess---------------------

  // ✅ FIRST declare data state
  const [data, setData] = useState(null);
  const [careerReport, setCareerReport] = useState(null);
  const celebrationRef = useRef(false);

  const badgeProgress = data?.badgeProgressDTO || {};

  const badges = [
    {
      name: "Problem Solver",
      slug: "problem-solver",
      image: problemSolver,
      percent: parseFloat(badgeProgress.problemSolver?.percentage || 0).toFixed(1),
    },
    {
      name: "Interview Ace",
      slug: "interview-ace",
      image: interviewAce,
      percent: parseFloat(badgeProgress.interviewAce?.percentage || 0).toFixed(1),
    },
    {
      name: "Problem Architect",
      slug: "problem-architect",
      image: problemArchitect,
      percent: parseFloat(
        badgeProgress.challengesChampion?.percentage || 0,
      ).toFixed(1),
    },
    {
      name: "Interview Maestro",
      slug: "interview-maestro",
      image: interviewMaestro,
      percent: parseFloat(
        badgeProgress.interviewMaestro?.percentage || 0,
      ).toFixed(1),
    },
    {
      name: "Algorithm Virtuoso",
      slug: "algorithm-virtuoso",
      image: algorithmVirtuoso,
      percent: parseFloat(
        badgeProgress.problemSolvingVirtuoso?.percentage || 0,
      ).toFixed(1),
    },
    {
      name: "Mission Master",
      slug: "mission-master",
      image: missionMaster,
      percent: parseFloat(
        badgeProgress.masterOfProblemSolver?.percentage || 0,
      ).toFixed(1),
    },
  ];

  useEffect(() => {
    if (!data?.badgeProgressDTO) return;

    const progress = data.badgeProgressDTO;
    const userId = data.userId || "default";

    const badgeList = [
      { name: "Problem Solver", percent: progress.problemSolverPercent },
      { name: "Interview Ace", percent: progress.interviewAcePercent },
      { name: "Mission Master", percent: progress.masterOfProblemSolverPercent },
      { name: "Interview Maestro", percent: progress.interviewMaestroPercent },
      {
        name: "Algorithm Virtuoso",
        percent: progress.problemSolvingVirtuosoPercent,
      },
      { name: "Problem Architect", percent: progress.challengesChampionPercent },
    ];

    // 🔥 KEYS
    const shownKey = `shownBadges_${userId}`;
    const stateKey = `badgeState_${userId}`;

    const shown = JSON.parse(localStorage.getItem(shownKey) || "[]");
    const prevState = JSON.parse(localStorage.getItem(stateKey) || "{}");

    const shownSet = new Set(shown);

    // 🔥 ONLY NEW UNLOCK (IMPORTANT)
    const newlyUnlocked = badgeList.filter((badge) => {
      const current = Number(badge.percent || 0);
      const previous = Number(prevState[badge.name] || 0);

      return current >= 99.9 && previous < 99.9 && !shownSet.has(badge.name);
    });

    // 🔥 ALWAYS SAVE CURRENT STATE
    const newState = {};
    badgeList.forEach((b) => {
      newState[b.name] = Number(b.percent || 0);
    });

    localStorage.setItem(stateKey, JSON.stringify(newState));

    if (newlyUnlocked.length === 0) return;

    // 🔥 MARK AS SHOWN
    newlyUnlocked.forEach((b) => shownSet.add(b.name));
    localStorage.setItem(shownKey, JSON.stringify([...shownSet]));

    // 🔥 MULTI-TAB SYNC (IMPORTANT)
    localStorage.setItem("badge_sync_event", Date.now());

    // 🎆 confetti
    const duration = 3000;
    const end = Date.now() + duration;

    const interval = setInterval(() => {
      if (Date.now() > end) {
        clearInterval(interval);
        return;
      }

      confetti({
        particleCount: 10,
        spread: 60,
        startVelocity: 30,
        origin: { x: Math.random(), y: Math.random() - 0.2 },
      });
    }, 400);

    Swal.fire({
      icon: "success",
      title: "🎉 Badge Unlocked!",
      html: newlyUnlocked
        .map(
          (b) =>
            `<div style="font-size:18px;font-weight:700;margin:6px 0;color:#8b5cf6">
            🏆 ${b.name}
          </div>`,
        )
        .join(""),
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
      allowOutsideClick: false,
      willClose: () => clearInterval(interval),
    });
  }, [data?.badgeProgressDTO]);

  useEffect(() => {
    const handler = () => {
      // jab dusre tab me badge show ho
      // yaha tum kuch bhi cleanup kar sakti ho (optional)
    };

    window.addEventListener("storage", handler);

    return () => window.removeEventListener("storage", handler);
  }, []);
  // -----------------------badgess---------------------

  const getVerdictColor = (verdict) => {
    const v = verdict?.toUpperCase() || "";

    if (v.includes("BEGINNER")) return "#ef4444";
    if (v.includes("INTERMEDIATE")) return "#f59e0b";
    if (v.includes("ADVANCED")) return "#22c55e";
    if (v.includes("EXPERT")) return "#14C38E";
    if (v.includes("EVOLVING")) return "#6366f1";
    if (v.includes("RUSHED")) return "#ef4444";

    return "#40c752";
  };

  const getVerdictLabel = (verdict) => {
    const v = verdict?.toUpperCase() || "";

    if (v.includes("BEGINNER")) return "BEGINNER";
    if (v.includes("INTERMEDIATE")) return "INTERMEDIATE";
    if (v.includes("ADVANCED")) return "ADVANCED";
    if (v.includes("EVOLVING")) return "EVOLVING ";
    if (v.includes("INTERVIEW_READY")) return "INTERVIEW READY";
    if (v.includes("HIRED")) return "HIRED (Interview Ready)";
    if (v.includes("NEEDS")) return "NEEDS PRACTICE";
    if (v.includes("AT RISK")) return "AT RISK";
    if (v.includes("NOT")) return "NOT READY";

    return "N/A";
  };

  const getScoreColor = (value) => {
    if (value >= 70) return "#3EC70B";
    if (value >= 33) return "#3B44F6";
    return "#FF4848";
  };

  const kpiColor = (type) => {
    switch (type) {
      case "max":
        return "#00CAFF";
      case "final":
        return "#16C47F";
      case "easy":
        return "#FA9905";
      case "hard":
        return "#D91656";
      case "skip":
        return "#143F6B";
      default:
        return "#2CD3E1";
    }
  };

  const KPI = ({ title, value, type }) => {
    const color = kpiColor(type);

    return (
      <div
        style={{
          background: "#fff",
          borderRadius: 18,
          padding: 18,
          borderLeft: `6px solid ${color}`,
          boxShadow: "0 10px 24px rgba(0,0,0,.06)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b" }}>
            {title}
          </div>

          <div
            style={{
              fontSize: 22,
              fontWeight: 900,
              color,
              marginTop: 4,
            }}
          >
            {Number(value || 0).toFixed(2)}
          </div>
        </div>

        <div
          style={{
            width: 46,
            height: 46,
            borderRadius: "50%",
            border: `2px solid ${color}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            fontSize: 13,
            color,
          }}
        >
          {Math.round(value || 0)}%
        </div>
      </div>
    );
  };

  // ----------------------------------------------
  const [showAll, setShowAll] = React.useState(false);
  const [combinedReport, setCombinedReport] = useState(null);
  const qa = combinedReport?.qualityAnalysis || {};

  const [showAllSpeed, setShowAllSpeed] = React.useState(false);
  const radarData = React.useMemo(() => {
    const raw = combinedReport?.topicStrengthMap || {};

    return Object.entries(raw).map(([topic, value]) => ({
      subject: topic,
      value: Number(value) || 0,
    }));
  }, [combinedReport]);

  const sortedData = [...radarData].sort((a, b) => b.value - a.value);
  const displayedData = showAll ? sortedData : sortedData.slice(0, 5);

  // ----------------all graphs combine--------------

  const [combinedLoading, setCombinedLoading] = useState(false);
  const [, forceUpdate] = useState(0);
  const [resumeMap, setResumeMap] = useState({});

  const verdict = combinedReport?.verdict || "N/A";

  // ================= REAL GRAPH DATA =================

  const activityData =
    combinedReport?.dailyActivityTrend?.map((item, index) => ({
      cindex: index + 1,
      date: item.date,
      tests: item.testCount,
      accuracy: item.avgAccuracy,
    })) || [];

  const dataCount = activityData.length;

  const dynamicBarSize =
    dataCount > 15 ? 28 : dataCount > 10 ? 34 : dataCount > 6 ? 40 : 46;

  const dynamicBarGap =
    dataCount > 15 ? 16 : dataCount > 10 ? 14 : dataCount > 6 ? 12 : 10;

  const quality = combinedReport?.timeStrategyPoints || {};
  const tsp = combinedReport?.timeStrategyPoints || {};

  const easy = Number(tsp.avgTimeEasy || 0);
  const medium = Number(tsp.avgTimeMedium || 0);
  const hard = Number(tsp.avgTimeHard || 0);

  const total = easy + medium + hard || 1;

  const verdictMap = {
    EXCELLENT: 100,
    GOOD: 75,
    AVERAGE: 50,
    POOR: 25,
  };

  const getVerdictPercent = (verdict) => {
    if (!verdict) return 0;

    const v = verdict.toUpperCase();

    if (v.includes("EXCELLENT")) return 100;
    if (v.includes("GOOD")) return 75;
    if (v.includes("AVERAGE")) return 50;
    if (v.includes("POOR")) return 25;
    if (v.includes("ANALYZED")) return 100;
    if (v.includes("BEGINNER")) return "#ef4444";
    if (v.includes("INTERMEDIATE")) return "#f59e0b";
    if (v.includes("ADVANCED")) return "#22c55e";
    if (v.includes("EXPERT")) return "#14C38E";
    if (v.includes("EVOLVING")) return "#6366f1";
    if (v.includes("RUSHED")) return "#ef4444";

    return 0;
  };

  const ChangeTime = (seconds) => {
    if (seconds < 60) {
      return `${seconds} sec`;
    }

    const minutes = seconds / 60;

    if (minutes < 60) {
      return `${minutes.toFixed(1)} min`;
    }

    const hours = minutes / 60;

    return `${hours.toFixed(1)} hr`;
  };

  const ringData = [
    {
      label: "Easy Time",
      percent: (easy / total) * 100,
      display: `${ChangeTime(easy)}`,
      color: "#6366f1",
    },
    {
      label: "Medium Time",
      percent: (medium / total) * 100,
      display: `${ChangeTime(medium)}`,
      color: "#22c55e",
    },
    {
      label: "Hard Time",
      percent: (hard / total) * 100,
      display: `${ChangeTime(hard)}`,
      color: "#f97316",
    },
    {
      label: "Verdict",
      percent: getVerdictPercent(tsp.timeManagementVerdict),
      display: tsp.timeManagementVerdict || "N/A",
      color: "#ef4444",
    },
  ];

  const timeManagementVerdict =
    combinedReport?.timeStrategyPoints?.timeManagementVerdict || "N/A";

  const radarHeight = Math.max(420, radarData.length * 24);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const radarDynamicHeight = isMobile
    ? Math.max(420, radarData.length * 30)
    : 520;

  // -------------------------------time--------------

  const formatTime = (minutes) => {
    if (!minutes && minutes !== 0) return "0 min";
    if (minutes < 1) return `${Math.round(minutes * 60)} sec`;
    if (minutes < 60) return `${minutes} min`;

    const h = Math.floor(minutes / 60);
    const m = minutes % 60;

    return m === 0 ? `${h}h` : `${h}h ${m}m`;
  };

  const difficultyData = combinedReport?.difficultyBreakdown
    ? [
        { level: "Easy", value: combinedReport.difficultyBreakdown.easySolved },
        {
          level: "Medium",
          value: combinedReport.difficultyBreakdown.mediumSolved,
        },
        { level: "Hard", value: combinedReport.difficultyBreakdown.hardSolved },
      ]
    : [];

  const raw = Object.entries(combinedReport?.timeSpentPerTopic || {})
    .filter(([topic, seconds]) => seconds > 0)
    .map(([topic, seconds]) => ({
      name: topic.replace(/[-_:]/g, " ").trim(),
      value: Number((seconds / 60).toFixed(2)),
    }));

  const merged = {};

  raw.forEach((item) => {
    if (merged[item.name]) {
      merged[item.name] += item.value;
    } else {
      merged[item.name] = item.value;
    }
  });

  const timeData = React.useMemo(() => {
    const raw = Object.entries(combinedReport?.timeSpentPerTopic || {})
      .filter(([_, seconds]) => seconds > 0)
      .map(([topic, seconds]) => ({
        name: topic.replace(/[-_:]/g, " ").trim(),
        value: Number((seconds / 60).toFixed(2)),
      }));

    const merged = {};

    raw.forEach((item) => {
      merged[item.name] = (merged[item.name] || 0) + item.value;
    });

    return Object.entries(merged)
      .map(([name, value]) => ({
        name,
        value: Number(value.toFixed(2)),
      }))
      .sort((a, b) => b.value - a.value);
  }, [combinedReport]);

  // ===== PROGRESS TRACKER GRAPH DATA =====
  const progressData = React.useMemo(() => {
    if (!Array.isArray(combinedReport?.progressTracker)) return [];

    const grouped = {};

    combinedReport.progressTracker.forEach((t) => {
      const full = t.testName || "";

      let date = null;

      const dashFormat = full.match(/\d{4}-\d{2}-\d{2}/);
      if (dashFormat) {
        date = dashFormat[0];
      } else {
        const plainFormat = full.match(/\d{8}/);
        if (plainFormat) {
          const raw = plainFormat[0];
          date = `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`;
        }
      }

      if (!date) return;

      if (!grouped[date]) grouped[date] = [];

      grouped[date].push(Number(t.score) || 0);
    });

    return Object.entries(grouped)
      .map(([date, scores]) => {
        const avg =
          scores.length === 1
            ? scores[0]
            : scores.reduce((a, b) => a + b, 0) / scores.length;

        return {
          name: date,
          score: Number(avg.toFixed(1)),
          testCount: scores.length,
        };
      })
      .sort((a, b) => new Date(a.name) - new Date(b.name));
  }, [combinedReport]);

  const diffChart = Array.isArray(combinedReport?.difficultyAnalysis)
    ? combinedReport.difficultyAnalysis.map((d) => {
        const total = d.correct + d.wrong + d.skipped;

        return {
          level: d.level,
          accuracy: total === 0 ? 0 : Math.round((d.correct / total) * 100),
          correct: d.correct,
          wrong: d.wrong,
          skipped: d.skipped,
        };
      })
    : [];

  const dailyChart = Object.entries(combinedReport?.dailyActivity || {})
    .map(([date, minutes]) => ({
      date,
      minutes: Number(minutes || 0),
    }))
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  const performanceData = Object.entries(combinedReport?.dailyActivity || {})
    .map(([date, minutes]) => {
      const diff = combinedReport?.difficultyBreakdown || [];

      const totalCorrect = diff.reduce((s, d) => s + d.correct, 0);
      const totalQ = diff.reduce(
        (s, d) => s + d.correct + d.wrong + d.skipped,
        0,
      );

      const accuracy =
        totalQ === 0 ? 0 : Math.round((totalCorrect / totalQ) * 100);

      return {
        name: date,
        minutes: Number(minutes),
        accuracy,
        dateObj: new Date(date),
      };
    })
    .sort((a, b) => a.dateObj - b.dateObj);

  // ===== SPEED ACCURACY DATA =====
  const speedData = React.useMemo(() => {
    if (!Array.isArray(combinedReport?.speedAccuracyMatrix)) return [];

    const group = {};

    combinedReport.speedAccuracyMatrix.forEach((q) => {
      const topic = q.questionTopic;

      if (!group[topic]) {
        group[topic] = {
          topic,
          totalAccuracy: 0,
          count: 0,
          totalTime: 0,
        };
      }

      group[topic].totalAccuracy += Number(q.accuracy || 0);
      group[topic].totalTime += Number(q.timeTaken || 0);
      group[topic].count += 1;
    });

    return Object.values(group).map((g) => ({
      topic: g.topic,
      accuracy: Math.round(g.totalAccuracy / g.count),
      time: Math.round(g.totalTime / 60),
    }));
  }, [combinedReport]);

  // ===== TEMP FALLBACK DATA =====
  const buildHeatData = (daily = {}) => {
    const result = [];

    const start = new Date("2026-01-01");

    for (let i = 0; i < 365; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);

      const dateStr = d.toISOString().slice(0, 10);

      result.push({
        date: dateStr,
        value: Number(daily[dateStr] || 0),
        dayIndex: d.getDay(),
        weekIndex: Math.floor(i / 7),
        month: d.toLocaleString("en", { month: "short" }),
      });
    }

    return result;
  };

  const buildHeatDataFromTests = (trend = []) => {
    const map = {};

    trend.forEach((item) => {
      map[item.date] = item.testCount;
    });

    const result = [];
    const start = new Date("2026-01-01");

    for (let i = 0; i < 365; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);

      const dateStr = d.toISOString().slice(0, 10);

      result.push({
        date: dateStr,
        value: Number(map[dateStr] || 0),
        dayIndex: d.getDay(),
        weekIndex: Math.floor(i / 7),
        month: d.toLocaleString("en", { month: "short" }),
      });
    }

    return result;
  };

  const activityHeatData = buildHeatDataFromTests(
    combinedReport?.dailyActivityTrend || [],
  );

  const getHeatColor = (value) => {
    if (value === 0) return "#f1f5f9";

    if (value <= 2) return "#E9D5FF";
    if (value <= 4) return "#C084FC";
    if (value <= 6) return "#A855F7";
    if (value <= 8) return "#7E22CE";
    return "#4c1d95";
  };
  // ----------------------------------------------------------

  // -------------------------badgess--------------------------
  const [badgeData, setBadgeData] = useState(null);
  // -------------------------badgess--------------------------

  const difficultyStackData = React.useMemo(() => {
    const d = combinedReport?.difficultyBreakdown;
    if (!d) return [];

    return [
      { level: "Easy", correct: d.easySolved },
      { level: "Medium", correct: d.mediumSolved },
      { level: "Hard", correct: d.hardSolved },
    ];
  }, [combinedReport]);

  // ----------------all graphs combine--------------
  function normalize(str = "") {
    return str.toLowerCase().replace(/\s+/g, "").replace(/_/g, "");
  }

  const [report, setReport] = useState(null);
  const [reportLoading, setReportLoading] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [activeMenu, setActiveMenu] = useState(null);

  const [testList, setTestList] = useState([]);
  const [selectedReportTest, setSelectedReportTest] = useState("");

  const staminaData = React.useMemo(() => {
    if (!Array.isArray(combinedReport?.staminaTrend)) return [];

    return combinedReport.staminaTrend.map((item, index) => ({
      test: `Test ${index + 1}`,
      stamina: Number(item.score ?? 0),
      size: Number(item.score ?? 0) * 2,
    }));
  }, [combinedReport]);

  const difficulty = Array.isArray(report?.difficultyBreakdown)
    ? report.difficultyBreakdown
    : [];

  const totalCorrect = difficulty.reduce((sum, d) => sum + (d.correct || 0), 0);

  const totalAttempted = difficulty.reduce(
    (sum, d) => sum + (d.correct || 0) + (d.wrong || 0) + (d.skipped || 0),
    0,
  );

  const accuracyPercent =
    totalAttempted > 0 ? Math.round((totalCorrect / totalAttempted) * 100) : 0;

  // ===== COURSE FILTER DATA =====

  const [loading, setLoading] = useState(true);

  const attendanceDates = data?.attendanceDates || [];

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigate = useNavigate();
  const [savedCourse, setSavedCourse] = useState(() =>
    localStorage.getItem("selectedCourse"),
  );

  const [orderedSubs, setOrderedSubs] = useState([]);

  const updatePlan = (newPlan, courseId) => {
    const normalized = newPlan.toLowerCase();

    localStorage.setItem("selectedPlan", normalized);

    const existing = JSON.parse(localStorage.getItem("coursePlanMap") || "{}");

    existing[courseId] = normalized;

    localStorage.setItem("coursePlanMap", JSON.stringify(existing));

    console.log("🔥 PLAN MAP UPDATED:", existing);
  };

  useEffect(() => {
  if (!selectedSub) return; // wait until subscriptions load

  const fromFront = document.referrer.includes("/front");
  const plan = (selectedSub.planType || "free").toLowerCase();

  if (plan === "free" && fromFront) {
    Swal.fire({
      icon: "error",
      title: "Access Denied",
      text: "Please purchase course to access Quiz",
    });
    navigate("/courses");
  }
}, [selectedSub]);

  useEffect(() => {
    const handler = (e) => {
      if (
        e.message ===
          "ResizeObserver loop completed with undelivered notifications" ||
        e.message === "ResizeObserver loop limit exceeded"
      ) {
        e.stopImmediatePropagation();
      }
    };

    window.addEventListener("error", handler);

    return () => {
      window.removeEventListener("error", handler);
    };
  }, []);

  // --------------------------------------feedback backend yes or not -------------------------------

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const response = await axiosClient.get("/auth/dashboard");
        const finalData = response.data?.data || response.data;

        setData(finalData);
        localStorage.setItem("username", finalData.fullName);
        localStorage.setItem("dashboardData", JSON.stringify(finalData));
        const userId = localStorage.getItem("userId");

        const profile = finalData?.userCareerProfile;

        if (profile === undefined) return;

        if (!profile) {
          navigate("/feedback");
          return;
        }
      } catch (error) {
        if (error.response?.status === 401) navigate("/login");
        else if (error.response?.status === 302) {
          localStorage.removeItem("token");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  // 🔥 BUILD COURSE-WISE RESUME MAP
  useEffect(() => {
    const updateResume = () => {
      if (!data?.subscriptions) return;

      const map = {};
      const userId = localStorage.getItem("userId");

      const activeTest = JSON.parse(
        localStorage.getItem(`activeTest_${userId}`),
      );

      const currentTestName = localStorage.getItem(`testName_${userId}`);

      data.subscriptions.forEach((sub) => {
        const courseId = sub.courseId;

        if (
          activeTest &&
          activeTest.module === courseId &&
          activeTest.testName === currentTestName &&
          activeTest.inProgress === true &&
          activeTest.type === "CUSTOM"
        ) {
          map[courseId] = true;
        } else {
          map[courseId] = false;
        }
      });

      setResumeMap(map);
    };

    updateResume();
    window.addEventListener("resume-status-update", updateResume);

    return () => {
      window.removeEventListener("resume-status-update", updateResume);
    };
  }, [data]);



  useEffect(() => {
    const mode = localStorage.getItem("testMode");
    const userId = localStorage.getItem("userId");

    if (mode === "CUSTOM") return;

    const test = data?.testName?.[0];

    if (test) {
      localStorage.setItem(`testName_${userId}`, test);
      localStorage.removeItem(`activeTest_${userId}`);
    }
  }, [data]);

  const subscriptions = data?.subscriptions || [];

  useEffect(() => {
    if (!subscriptions.length) return;

    const activeCourses = subscriptions.map((s) => s.courseId);

    localStorage.setItem("activeCourses", JSON.stringify(activeCourses));

    console.log("✅ ACTIVE COURSES:", activeCourses);
  }, [subscriptions]);


  const paidSubscription = subscriptions.find(
    (s) => s.planType && s.planType.toLowerCase() !== "free",
  );

  const student = {
    name:
      data?.name ||
      data?.username ||
      data?.fullName ||
      storedUser?.name ||
      "Guest Scholar",
    email: data?.email || storedUser?.email || "No Email Found",
    uid: data?.userId || data?._id || storedUser?.id || "N/A",
    plan: data?.plan || storedUser?.plan || "free",
  };

  const career = data?.userCareerProfile || {};

  useEffect(() => {
    if (selectedSub?.courseId && student.uid !== "N/A") {
      fetchCombinedReport(selectedSub.courseId);
    }
  }, [selectedSub?.courseId, student.uid]);

  useEffect(() => {
    if (student.uid && student.uid !== "N/A") {
      localStorage.setItem("userId", student.uid);
      localStorage.setItem("reportUserId", student.uid);
      console.log("✅ Saved userId:", student.uid);
    }
  }, [student.uid]);

  useEffect(() => {
    if (!subscriptions.length) return;
    if (!student.uid || student.uid === "N/A") return;

    const storedCourse = localStorage.getItem("selectedCourse");

    let finalCourse;

    if (storedCourse) {
      finalCourse = subscriptions.find((s) => s.courseId === storedCourse);
    }

    if (!finalCourse) {
      finalCourse = subscriptions[0];
      localStorage.setItem("selectedCourse", finalCourse.courseId);
    }

    setSelectedSub(finalCourse);
    updatePlan(finalCourse.planType || "free", finalCourse.courseId);
  }, [subscriptions, student.uid]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) navigate("/login");
  }, [navigate]);

  const handleUnlockAlert = () => {
    Swal.fire({
      title: "<strong>Assessment Required!</strong>",
      icon: "info",
      html: "To see your <b>Performance Analytics</b>, you must complete your enrolled course tests first.",
      showCancelButton: true,
      confirmButtonText: "Go to Courses",
      confirmButtonColor: "#8b5cf6",
      cancelButtonText: "Later",
      background: "#fff",
      customClass: { popup: "rounded-premium-alert" },
    }).then((result) => {
      if (result.isConfirmed) navigate("/courses");
    });
  };

  // -----------calender----------------

  const dateRef = useRef(new Date());

  const [monthText, setMonthText] = useState("");
  const [todayText, setTodayText] = useState("");
  const [daysHTML, setDaysHTML] = useState("");

  const planType = selectedSub?.planType || student?.plan || "free";
  const isPaidPlan = planType.toLowerCase() !== "free";

  const handleSubscriptionChange = (key, value) => {
    const found = subscriptions.find((s) => s[key] === value);
    if (found) {
      setSelectedSub(found);
    }
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    background: "linear-gradient(90deg,#6366f1,#ec4899)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };

  const normalizeDate = (d) => {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x.getTime();
  };

  const attendanceSet = React.useMemo(() => {
    return new Set(attendanceDates.map((d) => normalizeDate(d)));
  }, [attendanceDates]);

  const presentSet = attendanceSet;

  useEffect(() => {
    const old = JSON.parse(localStorage.getItem("attendanceHistory") || "[]");

    const merged = [...new Set([...old, ...attendanceDates])];

    localStorage.setItem("attendanceHistory", JSON.stringify(merged));
  }, [attendanceDates]);

  const renderCalender = () => {
    const date = dateRef.current;

    const year = date.getFullYear();
    const month = date.getMonth();

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    setMonthText(months[month]);
    setTodayText(new Date().toDateString());

    let days = "";

    const firstDayIndex = new Date(year, month, 1).getDay();
    const lastDay = new Date(year, month + 1, 0).getDate();

    const todayTime = normalizeDate(new Date());

    for (let i = 0; i < firstDayIndex; i++) {
      days += `<div class="u-empty"></div>`;
    }

    for (let i = 1; i <= lastDay; i++) {
      const cellDate = new Date(year, month, i);
      const cellTime = normalizeDate(cellDate);

      let className = "u-day";

      if (cellTime === todayTime) {
        className += " u-today";
      }

      if (presentSet.has(cellTime)) {
        className += " u-present";
      } else if (cellTime < todayTime) {
        className += " u-absent";
      } else {
        className += " u-future";
      }

      days += `<div class="${className}">${i}</div>`;
    }
    setDaysHTML(days);
  };

  const prevMonth = () => {
    const date = dateRef.current;
    date.setMonth(date.getMonth() - 1);
    renderCalender();
  };

  const nextMonth = () => {
    const date = dateRef.current;
    date.setMonth(date.getMonth() + 1);
    renderCalender();
  };

  useEffect(() => {
    if (attendanceDates.length) {
      renderCalender();
    }
  }, [attendanceDates]);

  // ----------------------get carrer------------------------
useEffect(() => {
  const courseId = selectedSub?.courseId;
  if (!courseId) return;

  const fetchCareerReport = async () => {
    try {
      const res = await axiosClient.get("/auth/get-career-report", {
        params: { module: courseId },
      });
      setCareerReport(res.data?.data || null);
    } catch (err) {
      console.log("❌ Career report error", err);
    }
  };

  fetchCareerReport();
}, [selectedSub?.courseId]);

  // --------------------test report check api  -----------------

  const loadReportTests = async () => {
    try {
      const res = await axiosClient.get("/auth/all-test-names");
      const list = res.data?.data || res.data || [];

      const filteredList = list.filter((test) => {
        const t = test.toLowerCase();

        return !t.includes("daily_challenge") && !t.includes("reasoning");
      });

      setTestList(filteredList);
    } catch (err) {
      console.log("Test list error", err);
    }
  };

  const loadReviewTests = async () => {
    try {
      const res = await axiosClient.get("/auth/all-test-names");

      const list = res.data?.data || res.data || [];

      setTestList(list);
    } catch (err) {
      console.log("Test list error", err);
    }
  };

  // --------------all graphs combine report-----------------
  const fetchCombinedReport = async (courseId) => {
    try {
      if (!student.uid || student.uid === "N/A") return;

      setCombinedLoading(true);

      setCombinedReport(null);

      const res = await axiosClient.get("/auth/combined-module-report", {
        params: {
          module: courseId,
        },
      });

      console.log("🔥 MODULE:", courseId);
      console.log("🔥 API DATA:", res.data);

      setCombinedReport(res.data.data);
    } catch (err) {
      console.log("❌ Combined Report Error", err);
    } finally {
      setCombinedLoading(false);
    }
  };

  useEffect(() => {
    console.log("🔥 COMBINED REPORT:", combinedReport);
    console.log("🔥 OVERVIEW DATA:");
  }, [combinedReport, activityData]);

  useEffect(() => {
    console.log("📦 FULL API:", combinedReport);
    console.log("📌 difficulty RAW:", combinedReport?.difficulty);
    console.log("📌 time RAW:", combinedReport?.difficulty);
  }, [combinedReport]);

  useEffect(() => {
    const handler = () => forceUpdate((v) => v + 1);

    window.addEventListener("resume-status-update", handler);

    return () => window.removeEventListener("resume-status-update", handler);
  }, []);

  // -----------calender----------------

  const isOverallLocked = (combinedReport?.totalTestsTaken || 0) === 0;

  if (loading) {
    return (
      <div style={styles.loader}>
        <style>{`
              @keyframes zestyPulse { 0% { transform: scale(1); } 50% { transform: scale(1.1); } 100% { transform: scale(1); } }
              .zesty-loading-logo { animation: zestyPulse 1.5s ease-in-out infinite; width: 120px; }
            `}</style>
        <div style={{ textAlign: "center" }}>
          <img src="Zesty Hii1.png" className="zesty-loading-logo" alt="Zesty" />
          <div
            style={{
              letterSpacing: "5px",
              fontWeight: "900",
              color: "#8b5cf6",
              marginTop: "20px",
              fontSize: "14px",
            }}
          >
            PLEASE WAIT LOADING...
          </div>
        </div>
      </div>
    );
  }


  const startResumeFlow = () => {
    if (!selectedSub) {
      Swal.fire({
        icon: "warning",
        title: "Course Required",
        text: "Please purchase a course to access Quiz",
      }).then(() => navigate("/courses"));
      return;
    }

    const userId = localStorage.getItem("userId");

    if (!userId || userId === "N/A") {
      navigate("/login");
      return;
    }

    let mediaStream;
    let screenStream;
    let checkCamera = null;
    let monitorInterval = null;
    let quizTerminated = false;
    let video;
    let cameraInterval = null;
    let screenInterval = null;
    let screenVideo;
    let removeDevToolsProtection = null;

    async function sendEvidence(screenImage, cameraImage, eliminationReason = null) {
      const testName = localStorage.getItem("testName") || "UNKNOWN_TEST";
      const token = localStorage.getItem("token");

      const payload = {
        userId: String(data.userId),
        testName: testName,
        elimination: eliminationReason ? String(eliminationReason) : null,
        screenCapture: screenImage ? [screenImage] : [],
        cameraCapture: cameraImage ? [cameraImage] : [],
      };

      console.log("Sending payload:", payload);

      try {
        const res = await axiosClient.post("/auth/saveEvidence", payload);
        console.log("SERVER RESPONSE:", res.data);

        if (eliminationReason) {
          const finishPayload = {
            userId: String(data.userId),
          };

          await axiosClient.post("/auth/finish-test", finishPayload, {
            params: { testName },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          console.log("Test finished automatically after violation");
        }
      } catch (error) {
        console.log("API ERROR:", error.response?.data || error.message);
      }
    }
    window.sendEvidence = sendEvidence;

    function captureCameraScreenshot(video) {
      if (!video || video.readyState < 2) {
        console.log("Camera not ready for screenshot");
        return null;
      }

      const canvas = document.createElement("canvas");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(video, 0, 0);

      return canvas.toDataURL("image/jpeg", 0.6);
    }
    function captureScreenScreenshot() {
      if (!screenVideo || screenVideo.readyState < 2) {
        console.log("Screen video not ready");
        return null;
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = screenVideo.videoWidth;
      canvas.height = screenVideo.videoHeight;

      ctx.drawImage(screenVideo, 0, 0);

      return canvas.toDataURL("image/jpeg", 0.6);
    }

    window.captureCameraScreenshot = captureCameraScreenshot;
    window.captureScreenScreenshot = captureScreenScreenshot;

    async function sendScreenshot(type, image) {
      const payload = {
        type: type,
        image: image,
      };

      console.log("Sending Screenshot:", payload);
    }

    function startScreenshotMonitoring() {
      screenInterval = setInterval(() => {
        const screenImage = captureScreenScreenshot();

        if (screenImage) {
          sendEvidence(screenImage, null, null);
        }

        console.log("1 min screen sent");
      }, 60000);

      cameraInterval = setInterval(() => {
        const cameraImage = captureCameraScreenshot(video);

        if (cameraImage) {
          sendEvidence(null, cameraImage, null);
        }

        console.log("Camera captured & sent");
      }, 120000);
    }

    function triggerViolation(title, text, reason, video) {
      if (quizTerminated) return;
      quizTerminated = true;

      if (checkCamera) clearInterval(checkCamera);
      if (monitorInterval) clearInterval(monitorInterval);
      if (cameraInterval) clearInterval(cameraInterval);
      if (screenInterval) clearInterval(screenInterval);

      if (removeDevToolsProtection) removeDevToolsProtection();

      const cameraImage = captureCameraScreenshot(video);
      const screenImage = captureScreenScreenshot();

      sendEvidence(screenImage, cameraImage, reason);
      stopCamera();

      Swal.fire({
        icon: "error",
        title: title,
        text: text,
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        navigate("/front");
      });
    }

    function stopCamera() {
      quizTerminated = true;

      if (checkCamera) clearInterval(checkCamera);
      if (monitorInterval) clearInterval(monitorInterval);
      if (cameraInterval) clearInterval(cameraInterval);
      if (screenInterval) clearInterval(screenInterval);

      if (mediaStream) {
        mediaStream.getTracks().forEach((track) => track.stop());
        mediaStream = null;
      }

      if (screenStream) {
        screenStream.getTracks().forEach((track) => track.stop());
        screenStream = null;
      }

      const video = document.querySelector("video");
      if (video) video.remove();

      console.log("Monitoring stopped, camera stopped");
    }
    window.stopCamera = stopCamera;

    if (screenStream) {
      screenStream.getTracks().forEach((track) => track.stop());
      screenStream = null;
    }

    video = document.querySelector("video");
    if (video) video.remove();

    if (quizTerminated) return;
    const testNameFromAPI = data?.testName?.[0];

    if (testNameFromAPI) {
      localStorage.setItem("testName", testNameFromAPI);
    }
    Swal.fire({
      title: "Select Quiz Mode 🎯",
      text: "Choose how you want to start",
      showDenyButton: true,
      confirmButtonText: "Non-Filtered Quiz",
      denyButtonText: "Filtered Quiz",
      confirmButtonColor: "#6366f1",
      denyButtonColor: "#0ea5e9",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await faceapi.nets.tinyFaceDetector.loadFromUri("/models");

          mediaStream = await navigator.mediaDevices.getUserMedia({
            video: true,
            audio: true,
          });

          screenStream = await navigator.mediaDevices.getDisplayMedia({
            video: true,
          });
          screenVideo = document.createElement("video");
          screenVideo.srcObject = screenStream;
          screenVideo.muted = true;
          await screenVideo.play();
          await document.documentElement.requestFullscreen();
          startScreenshotMonitoring();

          const videoTrack = mediaStream.getVideoTracks()[0];
          const audioTrack = mediaStream.getAudioTracks()[0];

          const audioContext = new AudioContext();

          if (audioContext.state === "suspended") {
            await audioContext.resume();
          }
          const microphone = audioContext.createMediaStreamSource(mediaStream);

          const analyser = audioContext.createAnalyser();
          analyser.fftSize = 512;

          microphone.connect(analyser);

          const dataArray = new Uint8Array(analyser.frequencyBinCount);

          video = document.createElement("video");
          video.srcObject = mediaStream;
          window.quizVideo = video;
          video.autoplay = true;
          video.playsInline = true;
          video.muted = true;

          video.style.position = "fixed";
          video.style.right = "10px";
          video.style.bottom = "110px";
          video.style.width = "200px";
          video.style.zIndex = "9999";
          document.body.appendChild(video);

          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          function detectShutter() {
            if (video.readyState < 2) return false;

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const frame = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const pixels = frame.data;

            let darkPixels = 0;
            const totalPixels = pixels.length / 4;

            for (let i = 0; i < pixels.length; i += 4) {
              const r = pixels[i];
              const g = pixels[i + 1];
              const b = pixels[i + 2];

              const brightness = r * 0.299 + g * 0.587 + b * 0.114;

              if (brightness < 40) {
                darkPixels++;
              }
            }
            const darkRatio = darkPixels / totalPixels;

            return darkRatio > 0.9;
          }

          async function detectFace(video) {
            const detections = await faceapi.detectAllFaces(
              video,
              new faceapi.TinyFaceDetectorOptions(),
            );

            return detections.length;
          }
          let popupVisible = false;

          function detectTalking() {
            analyser.getByteFrequencyData(dataArray);

            let sum = 0;

            for (let i = 0; i < dataArray.length; i++) {
              sum += dataArray[i];
            }

            const volume = sum / dataArray.length;
            console.log("Volume:", volume);
            return volume;
          }
          video.onloadedmetadata = () => {
            setTimeout(() => {
              checkCamera = setInterval(() => {
                if (video.readyState < 2) {
                  return;
                }
                const shutterClosed = detectShutter();

                if (shutterClosed) {
                  if (!popupVisible) {
                    popupVisible = true;

                    Swal.fire({
                      icon: "warning",
                      title: "Camera is OFF 📷",
                      text: "Please open your camera to start the quiz",
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      showConfirmButton: false,
                    });
                  }
                } else {
                  clearInterval(checkCamera);
                  Swal.close();

                  document.addEventListener("visibilitychange", function () {
                    if (quizTerminated) return;

                    if (document.hidden) {
                      triggerViolation(
                        "Tab Switched 🚫",
                        "You switched tabs. You are eliminated.",
                        "TAB_SWITCH",
                        video,
                      );
                    }
                  });

                  removeDevToolsProtection = enableDevToolsProtection(
                    triggerViolation,
                    video,
                  );
                  document.addEventListener("keydown", (e) => {
                    if (quizTerminated) return;

                    if (e.key === "F11") {
                      e.preventDefault();

                      triggerViolation(
                        "Fullscreen key pressed 🚫",
                        "F11 is not allowed during exam",
                        "F11_PRESS",
                        video,
                      );
                    }

                    if (e.key === "Meta" || e.key === "OS") {
                      triggerViolation(
                        "Window Key Pressed 🚫",
                        "Window pressed Eliminated",
                        "WINDOWS KEY",
                        video,
                      );
                    }
                  });
                  document.addEventListener("fullscreenchange", () => {
                    if (!document.fullscreenElement) {
                      if (quizTerminated) return;

                      triggerViolation(
                        "Fullscreen exited 🚫",
                        "You exited fullscreen during the quiz",
                        "EXIT_FULLSCREEN",
                        video,
                      );
                    }
                  });
                  let noFaceCount = 0;
                  monitorInterval = setInterval(async () => {
                    const volume = detectTalking();

                    if (volume > 100) {
                      if (quizTerminated) return;
                      triggerViolation(
                        "Talking detected 🚫",
                        "Talking with someone eliminated",
                        "TALKING",
                        video,
                      );
                    }

                    const faceCount = await detectFace(video);

                    if (faceCount === 0) {
                      noFaceCount++;

                      console.log("No face count:", noFaceCount);

                      if (noFaceCount >= 6) {
                        if (quizTerminated) return;

                        triggerViolation(
                          "Face not detected 🚫",
                          "Please keep your face visible in the camera",
                          "FACE_NOT_VISIBLE",
                          video,
                        );
                      }
                    } else {
                      noFaceCount = 0;
                    }

                    if (faceCount > 1) {
                      if (quizTerminated) return;
                      triggerViolation(
                        "Multiple faces detected 🚫",
                        "Only one person allowed",
                        "MULTIPLE_FACES",
                        video,
                      );
                    }

                    if (videoTrack.readyState !== "live") {
                      if (quizTerminated) return;
                      triggerViolation(
                        "Camera Turned OFF 📷",
                        "Camera was turned off during quiz",
                        "CAMERA_OFF",
                        video,
                      );
                    }

                    if (audioTrack.readyState !== "live") {
                      if (quizTerminated) return;
                      triggerViolation(
                        "Microphone Turned OFF 🎤",
                        "Microphone was disabled",
                        "MIC_OFF",
                        video,
                      );
                    }

                    if (detectShutter()) {
                      if (quizTerminated) return;
                      triggerViolation(
                        "Camera blocked during quiz 📷",
                        "Camera was covered or blocked",
                        "CAMERA_BLOCKED",
                        video,
                      );
                    }
                  }, 5000);

                  const feedbackDone = localStorage.getItem(
                    `feedback_done_${userId}`,
                  );

                  if (feedbackDone !== "true") {
                    localStorage.setItem("after_feedback_redirect", "/quiz");

                    navigate("/feedback", {
                      replace: true,
                    });
                  } else {
                    navigate("/quiz", {
                      replace: true,
                    });

                    setTimeout(() => {
                      if (!document.fullscreenElement) {
                        document.documentElement.requestFullscreen();
                      }
                    }, 500);
                  }
                }
              }, 1000);
            }, 5000);
          };
        } catch (error) {
          console.log("Permission error:", error);

          if (mediaStream) {
            mediaStream.getTracks().forEach((track) => track.stop());
            mediaStream = null;
          }

          if (screenStream) {
            screenStream.getTracks().forEach((track) => track.stop());
            screenStream = null;
          }

          if (video) {
            video.srcObject = null;
            video.remove();
          }

          Swal.fire({
            icon: "warning",
            title: "Permission Required 🚫",
            text: "Camera and Microphone must be enabled.",
            showConfirmButton: false,
          });

          return;
        }
      }

      if (result.isDenied) {
        navigate("/coding");
      }
    });
  };

  /* =======================================================================
     TAB CONTENT BLOCKS
     ======================================================================= */

  const OverviewTab = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeading
        eyebrow="Course & subscription"
        title="Overview"
        desc="Pick a course, check your plan, and jump back into a paused test."
      />

     {!selectedSub && (
  <GetStartedCard
   userName={student.name !== "Guest Scholar" ? student.name.split(" ")[0] : ""}
    currentStep={1}
    onAction={() => navigate("/courses")}
  
  />

)}

    {selectedSub && (
        <Panel>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)",
              gap: 18,
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <label style={labelStyle}>Course Name</label>
              <select
                style={styles.dropdown}
                value={selectedSub?.courseId || ""}
                onChange={(e) => {
                  const selectedCourseId = e.target.value;

                  const found = subscriptions.find(
                    (s) => s.courseId === selectedCourseId,
                  );

                  setSelectedSub(found);
                
                  localStorage.setItem("selectedCourse", found.courseId);

                  if (found.planType) {
                    updatePlan(found.planType);
                  }
                }}
              >
                <option value="" disabled>
                  Select Course
                </option>
                {subscriptions.map((sub, i) => (
                  <option key={i} value={sub.courseId}>
                    {sub.courseId}
                  </option>
                ))}
              </select>

              {/* ADD COURSE BUTTON — lets user pick a different/new course */}
              <button
                onClick={() => {
                  navigate("/courses");
                }}
                style={{
                  marginTop: 6,
                  alignSelf: "flex-start",
                  padding: "6px 14px",
                  fontSize: "12px",
                  fontWeight: 600,
                  borderRadius: 10,
                  border: "1.5px solid #7c3aed",
                  cursor: "pointer",
                  background: "transparent",
                  color: "#7c3aed",
                  letterSpacing: 0.3,
                  transition: ".2s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#7c3aed";
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#7c3aed";
                }}
              >
                + Add Course
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <label style={labelStyle}>Plan Type</label>
              <select
                style={styles.dropdown}
                value={selectedSub?.planType || ""}
                disabled={!selectedSub}
                onChange={(e) => {
                  const newPlan = e.target.value;
                  handleSubscriptionChange("planType", newPlan);
                  updatePlan(newPlan);
                }}
              >
                <option value="" disabled>
                  Select Plan
                </option>
                {selectedSub &&
                  [...new Set(subscriptions.map((s) => s.planType))].map(
                    (plan, i) => (
                      <option key={i} value={plan}>
                        {plan}
                      </option>
                    ),
                  )}
              </select>

              {/* UPGRADE BUTTON — added below Plan Type dropdown */}
              {selectedSub && (
                <button
                  onClick={() => {
               
                    navigate("/payment");
                  }}
                  style={{
                    marginTop: 6,
                    alignSelf: "flex-start",
                    padding: "6px 14px",
                    fontSize: "12px",
                    fontWeight: 600,
                    borderRadius: 10,
                    border: "1.5px solid #7c3aed",
                    cursor: "pointer",
                    background: "transparent",
                    color: "#7c3aed",
                    letterSpacing: 0.3,
                    transition: ".2s",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#7c3aed";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "#7c3aed";
                  }}
                >
                  ⬆ Upgrade
                </button>
              )}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <label style={labelStyle}>Purchase Date</label>
              <select
                style={styles.dropdown}
                value={selectedSub?.purchaseDate || ""}
                disabled={!selectedSub}
                onChange={(e) =>
                  handleSubscriptionChange("purchaseDate", e.target.value)
                }
              >
                <option value="" disabled>
                  Select Purchase Date
                </option>
                {selectedSub &&
                  [...new Set(subscriptions.map((s) => s.purchaseDate))].map(
                    (date, i) => (
                      <option key={i} value={date}>
                        {date}
                      </option>
                    ),
                  )}
              </select>

              {selectedSub &&
                resumeMap[selectedSub.courseId] === true &&
                localStorage.getItem(
                  `activeTest_${localStorage.getItem("userId")}_${selectedSub.courseId}`,
                ) && (
                  <button
                    onClick={startResumeFlow}
                    style={{
                      marginTop: 12,
                      padding: "12px 26px",
                      fontSize: "14px",
                      fontWeight: 900,
                      borderRadius: 18,
                      border: "none",
                      cursor: "pointer",
                      background: T.gradient,
                      color: "#fff",
                      boxShadow: "0 10px 24px rgba(124,58,237,.35)",
                      letterSpacing: 1,
                      transition: ".3s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.04)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    ▶ RESUME TEST
                  </button>
                )}
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
              <label style={labelStyle}>Expiry Date</label>
              <select
                style={styles.dropdown}
                value={selectedSub?.expiryDate || ""}
                disabled={!selectedSub}
                onChange={(e) =>
                  handleSubscriptionChange("expiryDate", e.target.value)
                }
              >
                <option value="" disabled>
                  Select Expiry Date
                </option>
                {selectedSub &&
                  [...new Set(subscriptions.map((s) => s.expiryDate))].map(
                    (date, i) => (
                      <option key={i} value={date}>
                        {date}
                      </option>
                    ),
                  )}
              </select>
            </div>
          </div>

          {resumeMap[selectedSub?.courseId] && (
            <button
              onClick={() => {
                const userId = localStorage.getItem("userId");

                const activeTest = JSON.parse(
                  localStorage.getItem(`activeTest_${userId}`),
                );

                if (activeTest) {
                  navigate("/quiz");
                }
              }}
              style={{
                marginTop: "20px",
                padding: "12px 20px",
                borderRadius: "12px",
                border: "none",
                background: T.gradient,
                color: "#fff",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 6px 18px rgba(34,197,94,0.4)",
              }}
            >
              ▶ Resume Test
            </button>
          )}
        </Panel>
      )}

      <Panel>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <div style={styles.subText}>
            Email: <span style={styles.emailSpan}>{student.email}</span>
          </div>
          <div style={{ ...styles.subText, fontWeight: 700 }}>
            USER ID: <b>{student.uid}</b>
          </div>
        </div>
      </Panel>
    </div>
  );

  const CareerTab = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeading
        eyebrow="Career profile"
        title="Your career plan"
        desc="Target role, prep timeline, and the insight engine's read on your progress."
      />

      <Panel>
        <h3 style={{ marginTop: 0, marginBottom: 18, fontWeight: 800, color: T.ink }}>
          🎯 Career Profile
        </h3>

        {career ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(200px,1fr))",
              gap: "16px",
            }}
          >
            {[
              { label: "Target Company", value: career.targetCompany, icon: "🏢" },
              { label: "Target Role", value: career.targetRole, icon: "💼" },
              {
                label: "Preparation Deadline",
                value: `${career.preparationDeadlineMonths || 0} Months`,
                icon: "⏳",
              },
              {
                label: "Coding Experience",
                value: career.priorCodingExperience,
                icon: "💻",
              },
              {
                label: "Daily Coding Hours",
                value: `${career.dailyCodingHours || 0} hrs/day`,
                icon: "⏰",
              },
              { label: "Education", value: career.currentEducation, icon: "🎓" },
              {
                label: "Preferred Language",
                value: career.preferredLanguage,
                icon: "⚙️",
              },
              {
                label: "Non Tech Background",
                value:
                  career.nonTechBackground === true
                    ? "Non-Tech"
                    : career.nonTechBackground === false
                      ? "Tech"
                      : career.nonTechBackground || "N/A",
                icon: "📚",
              },
            ].map((item, i) => (
              <div
                key={i}
                style={{
                  background: T.surfaceAlt,
                  borderRadius: "14px",
                  padding: "14px 16px",
                  border: `1px solid ${T.border}`,
                  borderLeft: `4px solid ${T.primary}`,
                  display: "flex",
                  flexDirection: "column",
                  gap: "6px",
                }}
              >
                <div style={{ fontSize: 12, fontWeight: 700, color: "#64748b" }}>
                  {item.icon} {item.label}
                </div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#0f172a" }}>
                  {item.value || "N/A"}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ padding: 20 }}>No Career Profile Found</div>
        )}
      </Panel>

      <Panel>
        <h3 style={{ marginTop: 0, marginBottom: 18, fontWeight: 800, color: T.ink }}>
          📖 Career Insight Engine
        </h3>

        <div style={gridContainer}>
          {careerReport?.strongPoints?.length > 0 && (
            <div style={{ ...cardBox, borderLeft: "6px solid #22c55e" }}>
              <h4 style={{ ...subHeadingStyle, color: "#22c55e" }}>💪 Strong Points</h4>
              <ul style={listStyle}>
                {(careerReport?.strongPoints || []).map((point, i) => (
                  <li key={i} style={{ marginBottom: "8px" }}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {careerReport?.weakPoints?.length > 0 && (
            <div style={{ ...cardBox, borderLeft: "6px solid #ef4444" }}>
              <h4 style={{ ...subHeadingStyle, color: "#ef4444" }}>⚠ Weak Points</h4>
              <ul style={listStyle}>
                {(careerReport?.weakPoints || []).map((point, i) => (
                  <li key={i} style={{ marginBottom: "8px" }}>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {careerReport?.dailyRoadmap && (
            <div style={{ ...cardBox, borderLeft: "6px solid #3b82f6" }}>
              <h4 style={{ ...subHeadingStyle, color: "#3b82f6" }}>📅 Daily Roadmap</h4>
              <ul style={listStyle}>
                {careerReport.dailyRoadmap
                  .split(".")
                  .filter((item) => item.trim() !== "")
                  .map((item, i) => (
                    <li key={i} style={{ marginBottom: "8px" }}>
                      {item.trim()}
                    </li>
                  ))}
              </ul>
            </div>
          )}

          {careerReport?.companyReadinessStatus && (
            <div style={{ ...cardBox, borderLeft: "6px solid #8b5cf6" }}>
              <h4 style={{ ...subHeadingStyle, color: "#8b5cf6" }}>🏢 Company Readiness</h4>
              <ul style={listStyle}>
                {careerReport.companyReadinessStatus
                  .split(".")
                  .filter((item) => item.trim() !== "")
                  .map((item, i) => (
                    <li key={i} style={{ marginBottom: "8px" }}>
                      {item.trim()}
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </div>
      </Panel>
    </div>
  );

  const AnalyticsTab = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeading
        eyebrow="Performance"
        title="Analytics"
        desc="Everything derived from your test attempts: accuracy, pacing, topic strength, and trends."
      />

      <div className="overall-wrapper" style={{ position: "relative" }}>
        {isOverallLocked && (
          <div className="overall-lock">
            <button
              className="overall-unlock-btn"
              onClick={() => {
                Swal.fire({
                  icon: "info",
                  title: "Complete Test Required",
                  text: "Please complete at least one test to unlock your full performance report.",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#8b5cf6",
                  background: "#ffffff",
                  borderRadius: "16px",
                });
              }}
            >
              🔓 Unlock Full Performance Insights
            </button>
          </div>
        )}

        <div className={isOverallLocked ? "overall-blur" : ""}>
          <div className="app">
            <div className="main">
              <header className="topbar">
                <div>
                  <h3 style={{ fontWeight: 800, letterSpacing: 0.6, color: "#0f172a" }}>
                    Overall Performance Report
                  </h3>
                  <span style={{ fontSize: 12, fontWeight: 600, color: "#64748b" }}>
                    📅{" "}
                    {new Date().toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                </div>

                <div className="whitePanel">
                  <div style={styles.statBox}>
                    <div style={styles.bigNumber}>
                      {combinedReport?.totalTestsTaken || 0}
                    </div>
                    <div style={styles.smallText}>Total Test Given</div>
                  </div>

                  <div style={styles.statBox}>
                    <div style={styles.bigNumber}>
                      {Number(combinedReport?.interviewReadinessScore || 0).toFixed(1)}
                    </div>
                    <div style={styles.smallText}>Overall Readiness Score</div>
                  </div>

                  <div style={styles.statBox}>
                    <div
                      style={{
                        ...styles.verdictText,
                        color: getVerdictColor(combinedReport?.verdict),
                      }}
                    >
                      {getVerdictLabel(combinedReport?.verdict)}
                    </div>
                    <div style={styles.smallText}>Verdict</div>
                  </div>

                  <div style={styles.dotRow}>
                    {[
                      { label: "NOT READY", color: "#B3005E" },
                      { label: "AT RISK", color: "#FFEA20" },
                      { label: "NEEDS PRACTICE", color: "#2CD3E1" },
                      { label: "HIRED", color: "#14C38E" },
                      { label: "INTERVIEW_READY", color: "#14c331" },
                    ].map((item, i) => {
                      const verdict = combinedReport?.verdict?.toUpperCase() || "";

                      const verdictMap = {
                        BEGINNER: "NOT READY",
                        INTERMEDIATE: "AT RISK",
                        ADVANCED: "NEEDS PRACTICE",
                        EXPERT: "HIRED",
                        EVOLVING: "NEEDS PRACTICE",
                        INTERVIEW_READY: "INTERVIEW_READY",
                        RUSHED: "AT RISK",
                      };

                      const current = verdictMap[verdict] || "";
                      const isActive = current === item.label;

                      const lightenColor = (color, opacity = 0.25) => {
                        return `${color}${Math.floor(opacity * 255)
                          .toString(16)
                          .padStart(2, "0")}`;
                      };
                      return (
                        <span
                          key={i}
                          style={{
                            ...styles.dot,
                            background: isActive
                              ? item.color
                              : lightenColor(item.color, 0.2),
                            transform: isActive ? "scale(1.4)" : "scale(1)",
                            boxShadow: isActive
                              ? `0 0 8px ${item.color}, 0 0 16px ${item.color}`
                              : "none",
                            transition: "all .4s ease",
                          }}
                        />
                      );
                    })}
                  </div>
                </div>
              </header>

              <section className="content">
                <div className="card">
                  <h4>Leakage Analysis (Quality)</h4>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                      gap: 16,
                      marginTop: 12,
                    }}
                  >
                    <KPI title="Accuracy" type="max" value={qa.accuracy} />
                    <KPI title="Logic Score" type="final" value={qa.logicScore} />
                    <KPI title="Consistency" type="easy" value={qa.consistency} />
                    <KPI title="Focus" type="hard" value={qa.focus} />
                    <KPI title="Speed" type="skip" value={qa.speed} />
                  </div>
                </div>

                <br />

                <div className="grid-2">
                  <div className="card graph-card">
                    <h4>Overview Usage</h4>

                    {activityData.length === 0 ? (
                      <div className="no-data">No Data From API</div>
                    ) : (
                      <div className="graph-wrapper">
                        <ResponsiveContainer width="100%" height={isMobile ? 300 : 320}>
                          <BarChart
                            data={activityData}
                            barGap={8}
                            barCategoryGap="25%"
                            margin={{ top: 30, right: 20, left: 0, bottom: 0 }}
                          >
                            <defs>
                              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#a855f7" />
                                <stop offset="100%" stopColor="#6d28d9" />
                              </linearGradient>
                              <filter id="shadow">
                                <feDropShadow
                                  dx="0"
                                  dy="6"
                                  stdDeviation="8"
                                  floodColor="#7c3aed"
                                  floodOpacity="0.25"
                                />
                              </filter>
                            </defs>

                            <CartesianGrid strokeDasharray="4 4" vertical={false} stroke="#e2e8f0" />

                            <XAxis
                              dataKey="date"
                              tick={{ fontSize: 11, fontWeight: 700, fill: "#64748b" }}
                              axisLine={false}
                              tickLine={false}
                            />

                            <YAxis
                              domain={[0, 100]}
                              axisLine={false}
                              tickLine={false}
                              tick={{ fill: "#64748b", fontSize: 12, fontWeight: 600 }}
                            />

                            <Tooltip
                              cursor={{ fill: "rgba(139,92,246,0.08)", radius: 10 }}
                              content={({ active, payload }) => {
                                if (!active || !payload || !payload.length) return null;
                                const d = payload[0]?.payload;
                                return (
                                  <div
                                    style={{
                                      background: "rgba(255,255,255,0.95)",
                                      backdropFilter: "blur(12px)",
                                      border: "1px solid #ede9fe",
                                      borderRadius: 18,
                                      padding: "14px 16px",
                                      boxShadow: "0 10px 35px rgba(0,0,0,0.12)",
                                      minWidth: 200,
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: 800,
                                        fontSize: 15,
                                        color: "#7c3aed",
                                        marginBottom: 8,
                                      }}
                                    >
                                      📊 Daily Performance
                                    </div>
                                    <div style={{ color: "#475569", fontWeight: 600, marginBottom: 6 }}>
                                      📅 {d.date}
                                    </div>
                                    <div style={{ fontSize: 22, fontWeight: 800, color: "#0f172a" }}>
                                      {Number(d.accuracy).toFixed(1)}%
                                    </div>
                                  </div>
                                );
                              }}
                            />

                            <Bar
                              dataKey="accuracy"
                              radius={[16, 16, 0, 0]}
                              barSize={isMobile ? 28 : 48}
                              animationDuration={1000}
                              filter="url(#shadow)"
                            >
                              {activityData.map((entry, index) => (
                                <Cell key={index} fill="url(#barGradient)" style={{ transition: "all .3s ease" }} />
                              ))}
                              <LabelList
                                dataKey="accuracy"
                                position="top"
                                formatter={(v) => `${Number(v).toFixed(0)}%`}
                                style={{ fill: "#312e81", fontWeight: 800, fontSize: 12 }}
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    )}
                  </div>

                  <div className="card">
                    <h4>Average Quality Analysis</h4>

                    <div className="quality-wrapper">
                      <div className="ring-box">
                        <svg viewBox="0 0 320 320" className="quality-svg">
                          <defs>
                            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#c084fc" />
                              <stop offset="100%" stopColor="#7c3aed" />
                            </linearGradient>
                            <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#4ade80" />
                              <stop offset="100%" stopColor="#16a34a" />
                            </linearGradient>
                            <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#fb923c" />
                              <stop offset="100%" stopColor="#ea580c" />
                            </linearGradient>
                            <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
                              <stop offset="0%" stopColor="#fb7185" />
                              <stop offset="100%" stopColor="#e11d48" />
                            </linearGradient>
                            <filter id="softGlow">
                              <feDropShadow dx="0" dy="0" stdDeviation="6" floodOpacity="0.25" />
                            </filter>
                          </defs>

                          {ringData.map((ring, index) => {
                            const size = 320;
                            const center = size / 2;
                            const strokeWidth = 16;
                            const gap = 12;
                            const radius = center - (strokeWidth + gap) * index - strokeWidth * 1.8;
                            const circumference = 2 * Math.PI * radius;
                            const offset = circumference - (ring.percent / 100) * circumference;
                            const gradients = ["url(#grad1)", "url(#grad2)", "url(#grad3)", "url(#grad4)"];

                            return (
                              <g key={index}>
                                <circle
                                  cx={center}
                                  cy={center}
                                  r={radius}
                                  fill="none"
                                  stroke="rgba(226,232,240,0.55)"
                                  strokeWidth={strokeWidth}
                                />
                                <circle
                                  cx={center}
                                  cy={center}
                                  r={radius}
                                  fill="none"
                                  stroke={gradients[index % gradients.length]}
                                  strokeWidth={strokeWidth}
                                  strokeDasharray={circumference}
                                  strokeDashoffset={offset}
                                  strokeLinecap="round"
                                  transform={`rotate(-90 ${center} ${center})`}
                                  filter="url(#softGlow)"
                                  style={{
                                    transition: "stroke-dashoffset 1.2s cubic-bezier(.34,1.56,.64,1)",
                                  }}
                                />
                                <text
                                  x={center}
                                  y={center - radius + 8}
                                  textAnchor="middle"
                                  fontSize="11"
                                  fontWeight="800"
                                  fill="#475569"
                                >
                                  {Number(ring.percent).toFixed(1)}%
                                </text>
                              </g>
                            );
                          })}
                        </svg>
                      </div>

                      <div className="quality-labels">
                        {ringData.map((ring, i) => {
                          const colors = ["#7c3aed", "#16a34a", "#ea580c", "#e11d48"];

                          return (
                            <div key={i} className="quality-item">
                              <div className="quality-left">
                                <span
                                  className="color-dot"
                                  style={{
                                    background: colors[i % colors.length],
                                    boxShadow: `0 6px 18px ${colors[i % colors.length]}55`,
                                  }}
                                />
                                <span className="quality-title">{ring.label}</span>
                              </div>
                              <div className="quality-value" style={{ color: colors[i % colors.length] }}>
                                {ring.display}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <h4 style={{ marginBottom: 14 }}>Combined Topic Strength</h4>

                  <div className="spider-scroll-wrapper">
                    <div className="spider-inner">
                      {radarData.length === 0 ? (
                        <div style={{ padding: 20, textAlign: "center" }}>No Topic Data</div>
                      ) : (
                        <ResponsiveContainer width="100%" height={isMobile ? 420 : 520}>
                          <RadarChart data={radarData} cx="50%" cy="50%" outerRadius={isMobile ? "68%" : "72%"}>
                            <PolarGrid gridType="polygon" stroke="#e2e8f0" radialLines={true} />
                            <PolarAngleAxis
                              dataKey="subject"
                              tick={{ fill: "#0f172a", fontSize: isMobile ? 10 : 12, fontWeight: 700 }}
                              tickLine={false}
                            />
                            <PolarRadiusAxis
                              angle={90}
                              domain={[0, 100]}
                              tickCount={6}
                              tick={{ fill: "#94a3b8", fontSize: 10 }}
                              axisLine={false}
                            />
                            <Tooltip
                              formatter={(value) => [`${Number(value).toFixed(1)}%`, "Score"]}
                              contentStyle={{
                                borderRadius: "16px",
                                border: "1px solid #e2e8f0",
                                background: "rgba(255,255,255,0.95)",
                                backdropFilter: "blur(10px)",
                                boxShadow: "0 10px 35px rgba(0,0,0,0.12)",
                                padding: "10px 14px",
                              }}
                              labelStyle={{ color: "#0f172a", fontWeight: 700 }}
                            />
                            <Radar
                              name="Performance"
                              dataKey="value"
                              stroke="#4f46e5"
                              strokeWidth={3}
                              fill="url(#radarGradient)"
                              fillOpacity={1}
                              dot={{ r: 5, fill: "#4f46e5", stroke: "#ffffff", strokeWidth: 2 }}
                              activeDot={{ r: 8, fill: "#7c3aed", stroke: "#fff", strokeWidth: 3 }}
                              style={{ filter: "drop-shadow(0 12px 22px rgba(79,70,229,.28))" }}
                            />
                            <defs>
                              <linearGradient id="radarGradient" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#6366f1" stopOpacity={0.65} />
                                <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0.15} />
                              </linearGradient>
                            </defs>
                          </RadarChart>
                        </ResponsiveContainer>
                      )}
                    </div>
                  </div>
                </div>

                <div className="card">
                  <h4>Daily Time Activity</h4>

                  <div style={{ overflowX: "hidden", paddingBottom: 10 }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(12, 1fr)",
                        marginLeft: 36,
                        marginBottom: 6,
                        fontSize: 12,
                        color: "#64748b",
                      }}
                    >
                      {[
                        "Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec",
                      ].map((m, i) => (
                        <span key={i}>{m}</span>
                      ))}
                    </div>

                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateRows: "repeat(7, 1fr)",
                          marginRight: 6,
                          fontSize: 12,
                          color: "#64748b",
                          height: "100%",
                          alignItems: "center",
                        }}
                      >
                        <span style={{ gridRow: 2 }}>Mon</span>
                        <span style={{ gridRow: 4 }}>Wed</span>
                        <span style={{ gridRow: 6 }}>Fri</span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "repeat(53, 1fr)",
                          gridTemplateRows: "repeat(7, 1fr)",
                          gap: 3,
                          width: "100%",
                        }}
                      >
                        {activityHeatData.map((d, i) => (
                          <div
                            key={i}
                            title={`${d.value} on ${d.date}`}
                            style={{
                              gridRow: d.dayIndex + 1,
                              gridColumn: d.weekIndex + 1,
                              borderRadius: 4,
                              background: getHeatColor(d.value),
                              boxShadow: d.value > 0 ? "0 2px 6px rgba(124,58,237,.25)" : "none",
                              transition: "all .2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.18)";
                              e.currentTarget.style.zIndex = "10";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.zIndex = "1";
                            }}
                          />
                        ))}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 6,
                        marginTop: 10,
                        fontSize: 12,
                      }}
                    >
                      Less
                      <span style={{ width: 10, height: 10, background: "#f1f5f9" }} />
                      <span style={{ width: 10, height: 10, background: "#ddd6fe" }} />
                      <span style={{ width: 10, height: 10, background: "#c4b5fd" }} />
                      <span style={{ width: 10, height: 10, background: "#7c3aed" }} />
                      <span style={{ width: 10, height: 10, background: "#4c1d95" }} />
                      More
                    </div>
                  </div>
                </div>

                <div className="card">
                  <h4>Difficulty Analysis</h4>

                  {difficultyStackData.length === 0 ? (
                    <div style={{ padding: 20 }}>No Difficulty Data</div>
                  ) : (
                    <div
                      className="difficulty-scroll-wrapper"
                      style={{ overflowX: isMobile ? "auto" : "hidden", width: "100%", paddingBottom: 10 }}
                    >
                      <div style={{ minWidth: isMobile ? 700 : "100%", height: 420 }}>
                        <ResponsiveContainer width="100%" height="100%">
                          <BarChart
                            data={difficultyStackData}
                            barGap={6}
                            barCategoryGap="22%"
                            margin={{ top: 40, right: 20, left: 0, bottom: 10 }}
                          >
                            <defs>
                              <linearGradient id="correctGrad" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#c084fc" />
                                <stop offset="100%" stopColor="#7c3aed" />
                              </linearGradient>
                              <linearGradient id="wrongGrad" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#f472b6" />
                                <stop offset="100%" stopColor="#db2777" />
                              </linearGradient>
                              <linearGradient id="skipGrad" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="#cbd5e1" />
                                <stop offset="100%" stopColor="#64748b" />
                              </linearGradient>
                              <filter id="barGlow">
                                <feDropShadow dx="0" dy="5" stdDeviation="8" floodColor="#7c3aed" floodOpacity="0.18" />
                              </filter>
                            </defs>

                            <CartesianGrid vertical={false} strokeDasharray="4 4" stroke="#e2e8f0" />
                            <XAxis
                              dataKey="level"
                              axisLine={false}
                              tickLine={false}
                              tick={{ fill: "#475569", fontWeight: 700, fontSize: 13 }}
                            />
                            <YAxis
                              allowDecimals={false}
                              axisLine={false}
                              tickLine={false}
                              domain={[0, "dataMax + 5"]}
                              tick={{ fill: "#64748b", fontSize: 12, fontWeight: 600 }}
                            />
                            <Tooltip
                              cursor={{ fill: "rgba(124,58,237,0.05)" }}
                              contentStyle={{
                                borderRadius: 18,
                                background: "rgba(255,255,255,0.95)",
                                backdropFilter: "blur(12px)",
                                boxShadow: "0 10px 35px rgba(0,0,0,.12)",
                                border: "1px solid #ede9fe",
                                padding: "12px 14px",
                                fontWeight: 600,
                              }}
                              labelStyle={{ color: "#7c3aed", fontWeight: 800, marginBottom: 8 }}
                            />
                            <Bar
                              dataKey="correct"
                              stackId="a"
                              fill="url(#correctGrad)"
                              radius={[0, 0, 0, 0]}
                              barSize={55}
                              filter="url(#barGlow)"
                              animationDuration={1200}
                            />
                            <Bar
                              dataKey="wrong"
                              stackId="a"
                              fill="url(#wrongGrad)"
                              radius={[0, 0, 0, 0]}
                              barSize={55}
                              animationDuration={1400}
                            />
                            <Bar
                              dataKey="skipped"
                              stackId="a"
                              fill="url(#skipGrad)"
                              radius={[14, 14, 0, 0]}
                              barSize={55}
                              animationDuration={1600}
                            >
                              <LabelList
                                dataKey="skipped"
                                position="top"
                                formatter={(v, entry) => {
                                  const total = entry.correct + entry.wrong + entry.skipped;
                                  return total;
                                }}
                                style={{ fill: "#1e293b", fontWeight: 800, fontSize: 13 }}
                              />
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </div>
                    </div>
                  )}
                </div>

                <div className="card">
                  <h4>Stamina Trend</h4>

                  {staminaData.length === 0 ? (
                    <div style={{ padding: 20 }}>No Stamina Data</div>
                  ) : (
                    <ResponsiveContainer width="100%" height={320}>
                      <AreaChart data={staminaData} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                        <defs>
                          <linearGradient id="areaFill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#8b5cf6" stopOpacity={0.45} />
                            <stop offset="100%" stopColor="#8b5cf6" stopOpacity={0.03} />
                          </linearGradient>
                          <linearGradient id="lineStroke" x1="0" y1="0" x2="1" y2="0">
                            <stop offset="0%" stopColor="#6366f1" />
                            <stop offset="100%" stopColor="#ec4899" />
                          </linearGradient>
                        </defs>

                        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" />
                        <XAxis
                          dataKey="test"
                          tickLine={false}
                          axisLine={false}
                          tick={{ fill: "#64748b", fontSize: 11, fontWeight: 700 }}
                        />
                        <YAxis
                          domain={[0, 100]}
                          tickLine={false}
                          axisLine={false}
                          tick={{ fill: "#94a3b8", fontSize: 11 }}
                        />
                        <Tooltip
                          formatter={(v) => [`${v}%`, "Stamina"]}
                          cursor={{ stroke: "#8b5cf6", strokeWidth: 1, strokeDasharray: "5 5" }}
                          contentStyle={{
                            borderRadius: "16px",
                            border: "1px solid #e2e8f0",
                            background: "rgba(255,255,255,.95)",
                            backdropFilter: "blur(10px)",
                            boxShadow: "0 10px 30px rgba(0,0,0,.10)",
                            padding: "10px 14px",
                          }}
                          labelStyle={{ color: "#0f172a", fontWeight: 800 }}
                        />
                        <Area
                          type="monotone"
                          dataKey="stamina"
                          stroke="url(#lineStroke)"
                          strokeWidth={4}
                          fill="url(#areaFill)"
                          activeDot={{ r: 8, stroke: "#fff", strokeWidth: 3, fill: "#7c3aed" }}
                          dot={({ cx, cy, payload, index }) => {
                            const dotColors = ["#6366f1", "#8b5cf6", "#ec4899", "#f97316"];
                            return (
                              <>
                                <circle
                                  cx={cx}
                                  cy={cy}
                                  r={10}
                                  fill={dotColors[index % dotColors.length]}
                                  opacity={0.15}
                                />
                                <circle
                                  cx={cx}
                                  cy={cy}
                                  r={5}
                                  fill={dotColors[index % dotColors.length]}
                                  stroke="#fff"
                                  strokeWidth={2}
                                />
                                <text
                                  x={cx}
                                  y={cy - 14}
                                  textAnchor="middle"
                                  fontSize={11}
                                  fontWeight="800"
                                  fill="#0f172a"
                                >
                                  {payload.stamina}%
                                </text>
                              </>
                            );
                          }}
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  )}
                </div>

                {(() => {
                  if (!Array.isArray(timeData) || timeData.length === 0) return null;

                  const validTimeData = timeData.filter((item) => Number(item?.value || 0) > 0);
                  if (validTimeData.length === 0) return null;

                  const sorted = [...validTimeData].sort((a, b) => Number(b.value) - Number(a.value));
                  const visibleData = showAll ? sorted : sorted.slice(0, 5);
                  const max = Math.max(...sorted.map((t) => Number(t.value)));

                  return (
                    <div className="card">
                      <h4>Time Spent Per Topic</h4>

                      <div className="time-table-container">
                        {visibleData.map((item, i) => {
                          const gradients = [
                            "linear-gradient(90deg,#6366f1,#3b82f6)",
                            "linear-gradient(90deg,#22c55e,#10b981)",
                            "linear-gradient(90deg,#f97316,#facc15)",
                            "linear-gradient(90deg,#ec4899,#8b5cf6)",
                            "linear-gradient(90deg,#06b6d4,#3b82f6)",
                            "linear-gradient(90deg,#e11d48,#f43f5e)",
                          ];
                          const glowColors = [
                            "rgba(99,102,241,.35)",
                            "rgba(34,197,94,.35)",
                            "rgba(249,115,22,.35)",
                            "rgba(236,72,153,.35)",
                            "rgba(6,182,212,.35)",
                            "rgba(225,29,72,.35)",
                          ];
                          const percent = max === 0 ? 0 : (Number(item.value) / max) * 100;

                          return (
                            <div key={i} className="time-row">
                              <div className="topic-name" title={item.name}>
                                {item.name}
                              </div>
                              <div className="bar-area">
                                <div
                                  className="mini-bar"
                                  style={{
                                    width: `${percent}%`,
                                    background: gradients[i % gradients.length],
                                    boxShadow: `0 6px 14px ${glowColors[i % glowColors.length]}`,
                                    transition: "0.4s ease",
                                  }}
                                />
                              </div>
                              <div className="min-label">{item.value}m</div>
                            </div>
                          );
                        })}

                        {sorted.length > 5 && (
                          <div
                            style={{
                              textAlign: "center",
                              marginTop: 12,
                              cursor: "pointer",
                              fontSize: 13,
                              fontWeight: 700,
                              color: "#6366f1",
                            }}
                            onClick={() => setShowAll(!showAll)}
                          >
                            {showAll ? "▲ Show Less" : "▼ Show Top 5"}
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })()}

                <div className="card">
                  <h4>Leakage Analysis</h4>

                  {Array.isArray(combinedReport?.leakageAnalysis) &&
                  combinedReport.leakageAnalysis.length > 0 ? (
                    <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 10 }}>
                      {combinedReport.leakageAnalysis.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "14px 16px",
                            borderRadius: 12,
                            background: "#fff7ed",
                            borderLeft: "5px solid #f97316",
                            fontWeight: 600,
                            color: "#7c2d12",
                            boxShadow: "0 6px 14px rgba(0,0,0,.08)",
                          }}
                        >
                          ⚠ {item}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ padding: 20 }}>No Leakage Data</div>
                  )}
                </div>

                {(() => {
                  if (!Array.isArray(speedData) || speedData.length === 0) return null;

                  const validSpeedData = speedData.filter(
                    (item) => Number(item?.accuracy || 0) > 0 || Number(item?.time || 0) > 0,
                  );
                  if (validSpeedData.length === 0) return null;

                  const sorted = [...validSpeedData].sort((a, b) => Number(b.accuracy) - Number(a.accuracy));
                  const visibleData = showAllSpeed ? sorted : sorted.slice(0, 5);

                  return (
                    <div className="card">
                      <h4>Speed Accuracy Matrix</h4>

                      <div
                        className="bar-scroll-wrapper"
                        style={{ overflowX: isMobile ? "auto" : "hidden", overflowY: "hidden", width: "100%" }}
                      >
                        <div style={{ minWidth: isMobile ? 900 : "100%", height: Math.max(visibleData.length * 70, 400) }}>
                          <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                              data={visibleData}
                              layout="vertical"
                              margin={{ top: 20, right: 40, left: 60, bottom: 20 }}
                            >
                              <CartesianGrid strokeDasharray="3 3" opacity={0.15} />
                              <XAxis type="number" domain={[0, 100]} xAxisId="accuracy" tick={{ fontSize: 11 }} />
                              <XAxis
                                type="number"
                                orientation="top"
                                xAxisId="time"
                                domain={[0, "dataMax"]}
                                tick={{ fontSize: 11 }}
                              />
                              <YAxis
                                type="category"
                                dataKey="topic"
                                width={220}
                                tick={{ fontSize: 11, fontWeight: 600 }}
                              />
                              <Tooltip
                                content={({ payload }) => {
                                  if (!payload || !payload.length) return null;
                                  const d = payload[0].payload;
                                  return (
                                    <div
                                      style={{
                                        background: "linear-gradient(135deg,#ffffff,#f8fafc)",
                                        borderRadius: 16,
                                        padding: 14,
                                        boxShadow: "0 12px 28px rgba(0,0,0,.15)",
                                        minWidth: 180,
                                      }}
                                    >
                                      <div style={{ fontWeight: 800, fontSize: 14 }}>{d.topic}</div>
                                      <div style={{ marginTop: 6, fontSize: 12 }}>
                                        🎯 Accuracy: <b>{d.accuracy}%</b>
                                      </div>
                                      <div style={{ fontSize: 12 }}>
                                        ⏱ Time: <b>{d.time} min</b>
                                      </div>
                                    </div>
                                  );
                                }}
                              />
                              <Bar dataKey="accuracy" xAxisId="accuracy" radius={[0, 12, 12, 0]} animationDuration={800} barSize={50}>
                                {visibleData.map((entry, index) => {
                                  const colors = [
                                    "#6528F7","#0B666A","#FF6D28","#1CD6CE","#EA047E","#A555EC","#FFAF00",
                                  ];
                                  return <Cell key={`acc-${index}`} fill={colors[index % colors.length]} />;
                                })}
                                <LabelList
                                  content={({ x, y, width, height, index }) => {
                                    const item = visibleData[index];
                                    if (!item) return null;
                                    if (width < 60) return null;

                                    return (
                                      <g>
                                        <text
                                          x={x + width / 2}
                                          y={y + height / 2 - 6}
                                          textAnchor="middle"
                                          fill="#ffffff"
                                          fontSize="13"
                                          fontWeight="700"
                                        >
                                          🎯 {item.accuracy}%
                                        </text>
                                        <text
                                          x={x + width / 2}
                                          y={y + height / 2 + 10}
                                          textAnchor="middle"
                                          fill="#ffffff"
                                          fontSize="11"
                                          fontWeight="500"
                                        >
                                          ⏱ {item.time} min
                                        </text>
                                      </g>
                                    );
                                  }}
                                />
                              </Bar>
                              <Legend />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </div>

                      {sorted.length > 5 && (
                        <div
                          style={{
                            textAlign: "center",
                            marginTop: 12,
                            cursor: "pointer",
                            fontSize: 13,
                            fontWeight: 700,
                            color: "#6366f1",
                          }}
                          onClick={() => setShowAllSpeed(!showAllSpeed)}
                        >
                          {showAllSpeed ? "▲ Show Less" : "▼ Show Top 5"}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const BadgesTab = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeading
        eyebrow="Achievements"
        title="Badges"
        desc="Reach 100% on any badge to unlock its certificate."
      />

      <div className="dashboard-card badges-card">
        <div className="badges-header" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <h2 style={{ margin: 0 }}>Badges</h2>
          <span
            style={{
              fontSize: "16px",
              color: "#12458b",
              background: "#f1f5f9",
              padding: "4px 10px",
              borderRadius: "12px",
              fontWeight: "700",
            }}
          >
            Achieve 100% to claim certificate 🎓
          </span>
        </div>

        <div className="badge-wrapper">
          <div className="badge-strip">
            {badges.map((badge, i) => {
              const percent = badge.percent || 0;
              const isUnlocked = percent >= 100;

              const badgeGradients = [
                "linear-gradient(135deg,#6366f1)",
                "linear-gradient(135deg,#06b6d4)",
                "linear-gradient(135deg,#22c55e)",
                "linear-gradient(135deg,#f97316)",
                "linear-gradient(135deg,#ec4899)",
                "linear-gradient(135deg,#14b8a6)",
              ];

              const fillColor = badgeGradients[i % badgeGradients.length];

              return (
                <div key={i} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <div
                    className={`badge-card ${isUnlocked ? "unlocked" : ""}`}
                    onClick={() => {
                      if (badge.percent >= 100) {
                        navigate(`/badge/${badge.slug}`);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "Badge Locked 🔒",
                          text: "Complete 100% progress to unlock this badge.",
                          confirmButtonColor: "#7c3aed",
                        });
                      }
                    }}
                    style={{ cursor: "pointer", position: "relative" }}
                  >
                    <div className="liquid-wrapper">
                      <div className="liquid-fill" style={{ height: `${percent}%`, background: fillColor }} />
                      <img src={badge.image} alt={badge.name} className="badge-image" />
                      <div className="badge-percent">
                        {Number(percent).toFixed(1)}%
                        {badge.earnedDate && (
                          <div style={{ fontSize: "10px", marginTop: "4px", color: "#fff", fontWeight: "600" }}>
                            {new Date(badge.earnedDate).toLocaleDateString("en-IN", {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className="badge-status-text"
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: isUnlocked ? "#0d7232" : "#788597",
                    }}
                  >
                    {isUnlocked ? "Ready to Claim! 🎉" : "Reach 100% to unlock"}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );

  const CalendarTab = () => (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      <SectionHeading
        eyebrow="Attendance"
        title="Calendar"
        desc="Green means you showed up. Red means a missed day."
      />

      <div className="u-cal-dashboard-row">
        <div className="u-cal-container">
          <div className="u-cal-card">
            <div className="u-cal-months-header">
              <i className="fas fa-angle-left" onClick={prevMonth}></i>
              <div>
                <h1 className="u-cal-month-title">{monthText}</h1>
                <p className="u-cal-today-label">{todayText}</p>
              </div>
              <i className="fas fa-angle-right" onClick={nextMonth}></i>
            </div>

            <div className="u-cal-weekdays-row">
              <div className="u-cal-weekday-name">Sun</div>
              <div className="u-cal-weekday-name">Mon</div>
              <div className="u-cal-weekday-name">Tue</div>
              <div className="u-cal-weekday-name">Wed</div>
              <div className="u-cal-weekday-name">Thu</div>
              <div className="u-cal-weekday-name">Fri</div>
              <div className="u-cal-weekday-name">Sat</div>
            </div>

            <div className="u-cal-days-grid" dangerouslySetInnerHTML={{ __html: daysHTML }} />
          </div>
        </div>
      </div>
    </div>
  );

  const TAB_CONTENT = {
    overview: OverviewTab,
    career: CareerTab,
    analytics: AnalyticsTab,
    badges: BadgesTab,
    calendar: CalendarTab,
  };

  const ActiveTabContent = TAB_CONTENT[activeTab];

  return (
    <div style={styles.wrapper}>
      {isMenuOpen && <div style={styles.overlay} onClick={() => setIsMenuOpen(false)} />}

      <aside style={{ ...styles.sidebar, left: isMenuOpen ? "0" : "-280px" }} className="sidebar-main">
        <div style={styles.logoContainer}>
          <Link className="navbar-brand" to="/">
            <img id="logoimg" src="codematrixLogo.png" alt="logo" />
          </Link>
          {isMenuOpen && <X className="mobile-close-icon" onClick={() => setIsMenuOpen(false)} />}
        </div>
      </aside>

      <main style={styles.main}>
        <DashboardNavbar />
        <FloatingButtons />

        <br />

        <section style={{ ...styles.content, background: T.bg, paddingTop: 0 }}>
          {/* ===== PAGE HEADER ===== */}
          <div
            style={{
              marginTop: "8vh",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div>
              <div style={{ fontSize: 12, fontWeight: 800, color: T.primary, letterSpacing: 1 }}>
                DASHBOARD
              </div>
              <h1 style={{ margin: "4vh 0 0", fontSize: 26, fontWeight: 900, color: T.ink }}>
                Welcome back{student?.name && student.name !== "Guest Scholar" ? `, ${student.name}` : ""}
              </h1>
            </div>

            <div
              style={{
                display: "flex",
                gap: 10,
                fontSize: 12.5,
                color: T.inkSoft,
                fontWeight: 600,
              }}
            >
              <span>USER ID: <b style={{ color: T.ink }}>{student.uid}</b></span>
            </div>
          </div>

          {/* ===== TAB NAVIGATION ===== */}
          <div
            role="tablist"
            style={{
              display: "flex",
              gap: 6,
              marginTop: 22,
              marginBottom: 26,
              background: T.surface,
              border: `1px solid ${T.border}`,
              borderRadius: 16,
              padding: 6,
              boxShadow: T.shadow,
              overflowX: "auto",
            }}
          >
            {TABS.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.key;

              return (
                <button
                  key={tab.key}
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "10px 18px",
                    borderRadius: 12,
                    border: "none",
                    cursor: "pointer",
                    fontSize: 13.5,
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                    color: isActive ? "#fff" : T.inkSoft,
                    background: isActive ? T.gradient : "transparent",
                    boxShadow: isActive ? "0 8px 18px rgba(124,58,237,.28)" : "none",
                    transition: "all .2s ease",
                  }}
                >
                  <Icon size={16} />
                  {tab.label}
                </button>
              );
            })}
          </div>

          {/* ===== ACTIVE TAB ===== */}
          <ActiveTabContent />
        </section>
      </main>

      <DashboardStyles02 />
    </div>
  );
}